import { ExpedicaoNaoLiberadoSearch } from './expedicao-nao-liberado-search';
import { ExpedicaoSearch } from './expedicao-search';


export class ExpedicaoSearchPessoa {
    pedidoMaster: ExpedicaoSearch;
    pedidosNaoLiberados: ExpedicaoNaoLiberadoSearch[];
    pedidosDetail: ExpedicaoSearch[];

    constructor(props: Partial<ExpedicaoSearchPessoa>) {
        Object.assign(this, props);
        // Não Liberados
        this.constructorNaoLiberados(props?.pedidosNaoLiberados ?? []);
        // Pedidos
        this.constructorPedidos(props?.pedidosDetail ?? []);
    }

    /** Constructor dos pedidos não liberados */
    private constructorNaoLiberados(pedidos: ExpedicaoNaoLiberadoSearch[]) {
        if (pedidos && Array.isArray(pedidos)) {
            this.pedidosNaoLiberados = pedidos.map(pedido => new ExpedicaoNaoLiberadoSearch(pedido));
        } else {
            this.pedidosNaoLiberados = [];
        }
    }

    /** Constructor dos pedidos */
    private constructorPedidos(pedidos: ExpedicaoSearch[]) {
        if (pedidos && Array.isArray(pedidos)) {
            this.pedidosDetail = pedidos.map(pedido => new ExpedicaoSearch(pedido));
        } else {
            this.pedidosDetail = [];
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): ExpedicaoSearchPessoa {
        return new ExpedicaoSearchPessoa(JSON.parse(json));
    }
}
